export const SESSION_LENGTH = { minutes: 30 }
